














import { Component, Prop, Vue } from 'vue-property-decorator'
import ModuleBase from './ModuleBase'
import { ModuleDataItem } from '@/models/ModuleDataItem'
import ModuleItemForm from '@/components/ModuleItemForm.vue'
import Loader from '@/components/Loader.vue'

@Component({
	components: {
		ModuleItemForm,
		Loader,
	},
})
export default class NewModuleItem extends ModuleBase {

	private newModuleItem(item: ModuleDataItem) {
		item.set('moduleName', this.module.name)
		item.save().then(() => {
			this.$toasted.success('New item created.')
		}, (error: any) => {
			this.$toasted.error('Failed to create new item.')
		})
	}
}
